/**
 * Подложки поля — картинки пейзажа, поверх которых лежит гексагональная сетка
 * (см. createGroundBackground в GameScene).
 *
 * Перечень общий для клиента и сервера: сервер выбирает подложку один раз при
 * старте матча, кладет в игровое состояние и сохраняет в запись матча, а
 * клиент по этому же перечню знает, какую картинку грузить. Грузится РОВНО
 * ОДНА: распакованная текстура 4096x4096 занимает в видеопамяти около 64 МБ.
 *
 * Идентификаторы уезжают в базу вместе с записями матчей, поэтому менять
 * существующие нельзя — только добавлять новые. Если картинку все же убрали,
 * старые записи с ее идентификатором станут «неизвестными», и сервер выдаст им
 * случайную замену (см. resolveGroundBackground).
 *
 * ВОЛШЕБНЫЙ ЛЕС 1 СНЯТ С РАЗДАЧИ ВРЕМЕННО. Чтобы вернуть, надо расколдовать его
 * сразу в ТРЕХ местах этого файла — они помечены «волшебный лес 1: вернуть сюда»:
 *   GROUND_BACKGROUNDS           MAGICAL_FOREST_1: 'magical_forest_1'
 *   GROUND_BACKGROUND_IMAGES     [MAGICAL_FOREST_1]: '/img/ground/ground_magical_forest_1.jpg'
 *   HEX_GRID_COLOR_BY_BACKGROUND [MAGICAL_FOREST_1]: HEX_GRID_COLOR_LIGHT
 * Половинчатый возврат не пройдет: на каждое из этих мест есть тест.
 *
 * Снимать подложку с раздачи — по той же схеме: закомментировать ключ и ВСЕ
 * ссылки на него, пометив их. Оставлять ссылки при закомментированном ключе
 * нельзя: они превращаются в ключ undefined и ломают производные карты (так
 * было с солью, пока она была снята, — запасная подложка получала чужой цвет
 * сетки и затемненную пустую ячейку).
 *
 * Учти цену ожидания: старые записи матчей, игранные на снятой подложке, при
 * первом же просмотре НЕОБРАТИМО перекрашиваются в случайную подложку прямо в
 * БД (resolveGroundBackground -> ensureRecordingGroundBackground). Возврат
 * подложки потом их не восстановит.
 */
export const GROUND_BACKGROUNDS = {
  // волшебный лес 1: вернуть сюда — MAGICAL_FOREST_1: 'magical_forest_1' (временно отключен: сделать плато более ровным)
  MAGICAL_FOREST_2: 'magical_forest_2',
  SALT_1: 'salt_1',
  GREEN_1: 'green_1',
  GREEN_2: 'green_2',
  GREEN_3: 'green_3',
  GREEN_4: 'green_4',
  DESERT_1: 'desert_1',
  DESERT_2: 'desert_2',
  WINTER_1: 'winter_1',
  WINTER_2: 'winter_2',
  WINTER_3: 'winter_3',
  WINTER_4: 'winter_4',
  WINTER_5: 'winter_5',
  DEMON_1: 'demon_1',
  ASH_1: 'ash_1',
  GEYSER_1: 'geyser_1',
  BONE_1: 'bone_1',
  ISLAND_1: 'island_1',
  RED_1: 'red_1',
  VOLCANO_1: 'volcano_1',
  BOG_1: 'bog_1',
  MUSHROOM_1: 'mushroom_1',
  PLATO_1: 'plato_1',
  RICE_1: 'rice_1',
  SPIRAL_1: 'spiral_1',
};

export const GROUND_BACKGROUND_IMAGES = {
  [GROUND_BACKGROUNDS.GREEN_1]: '/img/ground/ground_green_1.jpg',
  [GROUND_BACKGROUNDS.GREEN_2]: '/img/ground/ground_green_2.jpg',
  [GROUND_BACKGROUNDS.GREEN_3]: '/img/ground/ground_green_3.jpg',
  [GROUND_BACKGROUNDS.GREEN_4]: '/img/ground/ground_green_4.jpg',
  [GROUND_BACKGROUNDS.DESERT_1]: '/img/ground/ground_desert_1.jpg',
  [GROUND_BACKGROUNDS.DESERT_2]: '/img/ground/ground_desert_2.jpg',
  [GROUND_BACKGROUNDS.WINTER_1]: '/img/ground/ground_winter_1.jpg',
  [GROUND_BACKGROUNDS.WINTER_2]: '/img/ground/ground_winter_2.jpg',
  [GROUND_BACKGROUNDS.WINTER_3]: '/img/ground/ground_winter_3.jpg',
  [GROUND_BACKGROUNDS.DEMON_1]: '/img/ground/ground_demon_1.jpg',
  [GROUND_BACKGROUNDS.SALT_1]: '/img/ground/ground_salt_1.jpg',
  [GROUND_BACKGROUNDS.ASH_1]: '/img/ground/ground_ash_1.jpg',
  [GROUND_BACKGROUNDS.GEYSER_1]: '/img/ground/ground_geyser_1.jpg',
  [GROUND_BACKGROUNDS.WINTER_4]: '/img/ground/ground_winter_4.jpg',
  [GROUND_BACKGROUNDS.BONE_1]: '/img/ground/ground_bone_1.jpg',
  [GROUND_BACKGROUNDS.ISLAND_1]: '/img/ground/ground_island_1.jpg',
  [GROUND_BACKGROUNDS.RED_1]: '/img/ground/ground_red_1.jpg',
  [GROUND_BACKGROUNDS.VOLCANO_1]: '/img/ground/ground_volcano_1.jpg',
  // волшебный лес 1: вернуть сюда — [GROUND_BACKGROUNDS.MAGICAL_FOREST_1]: '/img/ground/ground_magical_forest_1.jpg',
  [GROUND_BACKGROUNDS.MAGICAL_FOREST_2]: '/img/ground/ground_magical_forest_2.jpg',
  [GROUND_BACKGROUNDS.BOG_1]: '/img/ground/ground_bog_1.jpg',
  [GROUND_BACKGROUNDS.MUSHROOM_1]: '/img/ground/ground_mushroom_1.jpg',
  [GROUND_BACKGROUNDS.PLATO_1]: '/img/ground/ground_plato_1.jpg',
  [GROUND_BACKGROUNDS.RICE_1]: '/img/ground/ground_rice_1.jpg',
  [GROUND_BACKGROUNDS.SPIRAL_1]: '/img/ground/ground_spiral_1.jpg',
  [GROUND_BACKGROUNDS.WINTER_5]: '/img/ground/ground_winter_5.jpg',
};

export const GROUND_BACKGROUND_IDS = Object.values(GROUND_BACKGROUNDS);

/**
 * Запасная подложка: подставляется там, где выбор почему-то не доехал, чтобы
 * поле не осталось на голом черном фоне
 */
export const DEFAULT_GROUND_BACKGROUND = GROUND_BACKGROUNDS.GREEN_1;

/**
 * Известность считается по перечню идентификаторов, а не по карте картинок:
 * лишний ключ в производной карте (как было у снятой соли) иначе протекает
 * в санитайзер и записи матчей
 */
export const checkIfKnownGroundBackground = (backgroundId) =>
  typeof backgroundId === 'string' && GROUND_BACKGROUND_IDS.includes(backgroundId);

export const getRandomGroundBackground = () =>
  GROUND_BACKGROUND_IDS[Math.floor(Math.random() * GROUND_BACKGROUND_IDS.length)];

/**
 * Идентификатор подложки, годный к отрисовке: известный оставляем как есть,
 * все остальное (пустое поле у старых записей матчей, опечатка, снятая с
 * раздачи картинка) заменяем случайной
 */
export const resolveGroundBackground = (backgroundId) =>
  (checkIfKnownGroundBackground(backgroundId) ? backgroundId : getRandomGroundBackground());

export const getGroundBackgroundImage = (backgroundId) =>
  GROUND_BACKGROUND_IMAGES[backgroundId] || GROUND_BACKGROUND_IMAGES[DEFAULT_GROUND_BACKGROUND];

/**
 * Картинка пустой ячейки поля. Их две: обычная и затемненная — на светлом
 * снегу, соли, гейзерном пару и бледном песке спиралей пустые ячейки обычной
 * (светлой, почти белой) картинкой теряются, поэтому под такими подложками
 * поле рисуется затемненной.
 *
 * Подложки перечислены поименно, а не разобраны по имени файла: у новой
 * светлой подложки просто дописывается одна строка, и никакой зависимости
 * от того, как назван файл, при этом не возникает.
 */
export const EMPTY_HEX_IMAGES = {
  DEFAULT: '/img/hexes/empty_hex.7c5ee139.png',
  DARK: '/img/hexes/empty_hex_dark.fd2474c3.png',
};

const DARK_EMPTY_HEX_BACKGROUNDS = new Set([
  GROUND_BACKGROUNDS.WINTER_1,
  GROUND_BACKGROUNDS.WINTER_2,
  GROUND_BACKGROUNDS.WINTER_3,
  GROUND_BACKGROUNDS.SALT_1,
  GROUND_BACKGROUNDS.GEYSER_1,
  GROUND_BACKGROUNDS.WINTER_4,
  GROUND_BACKGROUNDS.SPIRAL_1,
  GROUND_BACKGROUNDS.WINTER_5,
]);

export const getEmptyHexImage = (backgroundId) => (
  DARK_EMPTY_HEX_BACKGROUNDS.has(backgroundId)
    ? EMPTY_HEX_IMAGES.DARK
    : EMPTY_HEX_IMAGES.DEFAULT
);

/**
 * Цвет контура гексагональной сетки. Подбирается под подложку: на темном
 * пепле и пекле сетку видно только светлой, на зеленой равнине светлая
 * наоборот лезет в глаза, снег, песок и гейзерный пар посередине.
 *
 * Как и с картинкой пустой ячейки, подложки перечислены поименно: имя файла
 * ничего не решает, а новая подложка обязана получить свой цвет — на это есть
 * тест, он не даст добавить ее молча.
 */
const HEX_GRID_COLOR_LIGHT = 0x909090;
const HEX_GRID_COLOR_MEDIUM = 0x707070;
const HEX_GRID_COLOR_DARK = 0x606060;

const HEX_GRID_COLOR_BY_BACKGROUND = {
  [GROUND_BACKGROUNDS.GREEN_1]: HEX_GRID_COLOR_DARK,
  [GROUND_BACKGROUNDS.GREEN_2]: HEX_GRID_COLOR_DARK,
  [GROUND_BACKGROUNDS.GREEN_3]: HEX_GRID_COLOR_DARK,
  [GROUND_BACKGROUNDS.GREEN_4]: HEX_GRID_COLOR_DARK,
  [GROUND_BACKGROUNDS.DESERT_1]: HEX_GRID_COLOR_MEDIUM,
  [GROUND_BACKGROUNDS.DESERT_2]: HEX_GRID_COLOR_MEDIUM,
  [GROUND_BACKGROUNDS.WINTER_1]: HEX_GRID_COLOR_MEDIUM,
  [GROUND_BACKGROUNDS.WINTER_2]: HEX_GRID_COLOR_MEDIUM,
  [GROUND_BACKGROUNDS.WINTER_3]: HEX_GRID_COLOR_MEDIUM,
  [GROUND_BACKGROUNDS.DEMON_1]: HEX_GRID_COLOR_LIGHT,
  [GROUND_BACKGROUNDS.SALT_1]: HEX_GRID_COLOR_MEDIUM,
  [GROUND_BACKGROUNDS.ASH_1]: HEX_GRID_COLOR_LIGHT,
  [GROUND_BACKGROUNDS.GEYSER_1]: HEX_GRID_COLOR_MEDIUM,
  [GROUND_BACKGROUNDS.WINTER_4]: HEX_GRID_COLOR_MEDIUM,
  // Кость, остров и красный каньон — светлый песок и камень, как пустыня
  [GROUND_BACKGROUNDS.BONE_1]: HEX_GRID_COLOR_MEDIUM,
  [GROUND_BACKGROUNDS.ISLAND_1]: HEX_GRID_COLOR_MEDIUM,
  [GROUND_BACKGROUNDS.RED_1]: HEX_GRID_COLOR_MEDIUM,
  // Вулкан, волшебный лес, болото и светящиеся грибы темные, как пепел
  [GROUND_BACKGROUNDS.VOLCANO_1]: HEX_GRID_COLOR_LIGHT,
  // волшебный лес 1: вернуть сюда — [GROUND_BACKGROUNDS.MAGICAL_FOREST_1]: HEX_GRID_COLOR_LIGHT,
  [GROUND_BACKGROUNDS.MAGICAL_FOREST_2]: HEX_GRID_COLOR_LIGHT,
  [GROUND_BACKGROUNDS.BOG_1]: HEX_GRID_COLOR_LIGHT,
  [GROUND_BACKGROUNDS.MUSHROOM_1]: HEX_GRID_COLOR_LIGHT,
  // Плато по яркости как зеленые равнины — сетка так же темная
  [GROUND_BACKGROUNDS.PLATO_1]: HEX_GRID_COLOR_DARK,
  // Рисовые террасы, бледный песок спиралей и лед — посередине, как пустыня и снег
  [GROUND_BACKGROUNDS.RICE_1]: HEX_GRID_COLOR_MEDIUM,
  [GROUND_BACKGROUNDS.SPIRAL_1]: HEX_GRID_COLOR_MEDIUM,
  [GROUND_BACKGROUNDS.WINTER_5]: HEX_GRID_COLOR_MEDIUM,
};

export const getHexGridColor = (backgroundId) =>
  HEX_GRID_COLOR_BY_BACKGROUND[backgroundId]
  ?? HEX_GRID_COLOR_BY_BACKGROUND[DEFAULT_GROUND_BACKGROUND];

/**
 * Темные подложки. Полупрозрачные элементы поля — картинка пустой ячейки
 * (HexGridRenderer, empty_hex) и иконки зоны кварталов
 * (HexGridRenderer.drawQuarterZoneMarker) — на них сливаются с фоном, поэтому
 * там они рисуются плотнее.
 *
 * Как и выше, подложки перечислены поименно: у новой темной подложки просто
 * дописывается одна строка.
 *
 * Сверка с перечнем идентификаторов обязательна: пока ключ подложки
 * закомментирован, ссылка на него здесь превращается в undefined, и без сверки
 * плотнее рисовалось бы и там, где подложка не выбралась.
 */
const DARK_GROUND_BACKGROUNDS = new Set([
  GROUND_BACKGROUNDS.VOLCANO_1,
  GROUND_BACKGROUNDS.MAGICAL_FOREST_2,
  GROUND_BACKGROUNDS.BOG_1,
  GROUND_BACKGROUNDS.MUSHROOM_1,
  GROUND_BACKGROUNDS.ISLAND_1
]);

const checkIfDarkGroundBackground = (backgroundId) =>
  checkIfKnownGroundBackground(backgroundId) && DARK_GROUND_BACKGROUNDS.has(backgroundId);

export const EMPTY_HEX_ALPHA = 0.5;
export const EMPTY_HEX_ALPHA_ON_DARK_BACKGROUND = 0.7;

export const getEmptyHexAlpha = (backgroundId) => (
  checkIfDarkGroundBackground(backgroundId)
    ? EMPTY_HEX_ALPHA_ON_DARK_BACKGROUND
    : EMPTY_HEX_ALPHA
);

/**
 * Светло-коричневый цвет штриховки зоны кварталов. Картинки штриховки
 * темно-коричневые, и на подложках, где пустая ячейка той же яркости, полосы
 * теряются: ячейку, где нельзя строить квартал, не отличить от ячейки, где можно
 * только базовый. Плотностью это не лечится — там полосы заливаются цветом
 * светлее, но того же тона. Светлые полосы рисуются плотно и там, где подложка
 * не темная (пекло, пепелище): при обычной прозрачности они слабые.
 *
 * Как и выше, подложки перечислены поименно.
 */
export const QUARTER_ZONE_MARKER_LIGHT_COLOR = 0xc49a6c;

const LIGHT_QUARTER_ZONE_MARKER_BACKGROUNDS = new Set([
  GROUND_BACKGROUNDS.DEMON_1,
  GROUND_BACKGROUNDS.ASH_1,
  GROUND_BACKGROUNDS.VOLCANO_1,
  GROUND_BACKGROUNDS.BOG_1,
  GROUND_BACKGROUNDS.MUSHROOM_1,
]);

const checkIfLightQuarterZoneMarkerBackground = (backgroundId) =>
  checkIfKnownGroundBackground(backgroundId) && LIGHT_QUARTER_ZONE_MARKER_BACKGROUNDS.has(backgroundId);

/**
 * @returns {number|null} цвет заливки полос; null — оставить цвет картинки
 */
export const getQuarterZoneMarkerFillColor = (backgroundId) => (
  checkIfLightQuarterZoneMarkerBackground(backgroundId)
    ? QUARTER_ZONE_MARKER_LIGHT_COLOR
    : null
);

export const QUARTER_ZONE_MARKER_ALPHA = 0.6;
export const QUARTER_ZONE_MARKER_ALPHA_DENSE = 0.85;

export const getQuarterZoneMarkerAlpha = (backgroundId) => (
  checkIfDarkGroundBackground(backgroundId) || checkIfLightQuarterZoneMarkerBackground(backgroundId)
    ? QUARTER_ZONE_MARKER_ALPHA_DENSE
    : QUARTER_ZONE_MARKER_ALPHA
);
